import { Head, useForm, Link } from '@inertiajs/react'
import { FormEvent } from 'react'
import { Button } from '@/components/ui/Button'
import { Input } from '@/components/ui/Input'
import { AuthLayout } from '@/components/layouts/AuthLayout'

interface Props {
  sent?: boolean
  email?: string
}

export default function ForgotPassword({ sent, email }: Props) {
  const { data, setData, post, processing, errors } = useForm({
    user: { email: '' },
  })

  const userErrors = errors as Record<string, string>

  const submit = (e: FormEvent) => {
    e.preventDefault()
    post('/users/password')
  }

  if (sent) {
    return (
      <AuthLayout>
        <Head title="Email envoyé - Tessan Community" />
        <div className="text-center">
          <div className="text-6xl mb-4">📧</div>
          <h1 className="text-2xl font-heading font-bold text-text-primary mb-4">Email envoyé !</h1>
          <p className="text-text-secondary mb-6">
            Si un compte existe avec l'adresse {email}, vous recevrez
            un email avec les instructions de réinitialisation.
          </p>
          <Link href="/users/sign_in">
            <Button variant="outline">Retour à la connexion</Button>
          </Link>
        </div>
      </AuthLayout>
    )
  }

  return (
    <AuthLayout>
      <Head title="Mot de passe oublié - Tessan Community" />

      <div className="text-center mb-8">
        <h1 className="text-3xl font-heading font-bold text-text-primary">Mot de passe oublié ?</h1>
        <p className="text-text-secondary mt-2">
          Entrez votre email pour recevoir un lien de réinitialisation
        </p>
      </div>

      <form onSubmit={submit} className="space-y-6">
        <Input
          label="Email"
          type="email"
          value={data.user.email}
          onChange={(e) => setData('user', { email: e.target.value })}
          error={userErrors['user.email']}
          required
          autoFocus
        />

        <Button type="submit" className="w-full" disabled={processing}>
          {processing ? 'Envoi...' : 'Envoyer le lien'}
        </Button>
      </form>

      <p className="text-center text-text-secondary mt-6">
        <Link href="/users/sign_in" className="text-tessan-green hover:underline">
          Retour à la connexion
        </Link>
      </p>
    </AuthLayout>
  )
}
